import React from "react";
import { withNamespaces } from 'react-i18next';

const AcTaxas = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_taxas">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="taxas_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#taxas_collapse1"
              aria-expanded="true"
              aria-controls="taxas_collapse1"
            >
              {t('moduleFaqs:S2.A.A1.T')}
            </button>
          </h2>
          <div
            id="taxas_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="taxas_heading1"
            data-bs-parent="#accordionExample_taxas"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul>
                  <li className="p_accordion">
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A1.LI1') }}>
                    </p>
                  </li>
                  <li className="p_accordion">
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A1.LI2') }}>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="taxas_heading2">
            <button
              className="accordion-button collapsed text-left"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#taxas_collapse2"
              aria-expanded="false"
              aria-controls="taxas_collapse2"
            >
              {t('moduleFaqs:S2.A.A2.T')}
            </button>
          </h2>
          <div
            id="taxas_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="taxas_heading2"
            data-bs-parent="#accordionExample_taxas"
          >
            <div className="accordion-body">
              <p className="p_accordion">
              <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A2.P1')}}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S2.A.A2.Link')} title={t('moduleFaqs:S2.A.A2.Title')}>{t('moduleFaqs:S2.A.A2.Link')}</a>
                <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A2.P2') }}></span>
              </p>
            </div>
          </div>
        </div>
        {/* 3*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="taxas_heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#taxas_collapse3"
              aria-expanded="false"
              aria-controls="taxas_collapse3"
            >
              {t('moduleFaqs:S2.A.A3.T')}
            </button>
          </h2>
          <div
            id="taxas_collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="taxas_heading3"
            data-bs-parent="#accordionExample_taxas"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A3.P') }}>
              </p>
            </div>
          </div>
        </div>
        {/* 4*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="taxas_heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#taxas_collapse4"
              aria-expanded="false"
              aria-controls="taxas_collapse4"
            >
              {t('moduleFaqs:S2.A.A4.T')}
            </button>
          </h2>
          <div
            id="taxas_collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="taxas_heading4"
            data-bs-parent="#accordionExample_taxas"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul>
                  <li className="p_accordion">
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A4.LI1') }}>
                    </p>
                  </li>
                  <li className="p_accordion">
                    <p className="p_next">
                      <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A4.LI2') }}></span>
                      <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S2.A.A4.Link.Link')} title={t('moduleFaqs:S2.A.A4.Link.Title')}>{t('moduleFaqs:S2.A.A4.Link.NameLink')}</a>
                      <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S2.A.A4.P') }}></span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 5*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="taxas_heading5">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#taxas_collapse5"
              aria-expanded="false"
              aria-controls="taxas_collapse5"
            >
              {t('moduleFaqs:S2.A.A5.T')}
            </button>
          </h2>
          <div
            id="taxas_collapse5"
            className="accordion-collapse collapse"
            aria-labelledby="taxas_heading5"
            data-bs-parent="#accordionExample_taxas"
          >
            <div className="accordion-body">
              <p className="p_accordion">
                {t('moduleFaqs:S2.A.A5.P')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcTaxas);
